<template>
	<inertia-head title="Payout Report" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Payout Report</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Welcome to TRC Admin Dashboard
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="row">
			<div class="col-lg-12">
				<div class="block block-rounded shadow mb-1">
					<div class="block-content">
						<form @submit.prevent="searchRecord(0)">
							<div class="row">
								<div class="col-md-3">
									<div class="form-group mb-4">
										<flat-pickr
											v-model="date_start"
											id="date_start"
											class="form-select"
											placeholder="Select start date"
										/>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group mb-4">
										<flat-pickr
											v-model="date_end"
											id="date_end"
											class="form-select"
											placeholder="Select end date"
										/>
									</div>
								</div>
								<div class="col space-x-1 mb-4">
									<input v-model="search" type="text" id="search" name="search" class="form-control" placeholder="Enter Search Info" />
								</div>
								<div class="col space-x-1 mb-4">
									<button type="submit" class="btn btn-alt-primary">
										<i class="fa fa-search me-1"></i>Display
									</button>
									<button
										@click="searchRecord(1)"
										type="button"
										class="btn btn-alt-secondary"
									>
										<i class="fa fa-retweet me-1"></i>Reset
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>

				<div class="block block-rounded">
					<div class="block-content block-content-full">
						<div class="border-bottom pb-1">
							<button @click="exportTo('csv')" type="button" class="btn btn-sm btn-alt-primary me-1"><i class="fa fa-download me-1"></i>CSV</button>
							<button @click="exportTo('excel')" type="button" class="btn btn-sm btn-alt-info me-1"><i class="fa fa-download me-1"></i>EXCEL</button>
							<a :href="SiteUrl+'/admin/affiliate-program/payout-report/print?search='+search+'&date_start='+date_start+'&date_end='+date_end" class="btn btn-sm btn-alt-success" target="_blank"><i class="fa fa-download me-1"></i>PRINT</a>
						</div>
						<div class="table-responsive">
							<table id="table_report" class="table table-striped table-borderless table-vcenter">
								<thead class="border-bottom">
									<tr>
										<th>MEMBER ID</th>
										<th>NAME</th>
										<th>EMAIL</th>
										<th>GROSS</th>
										<th>TAX WITHHELD</th>
										<th>FEE</th>
										<th>NET</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(member,m_index) in payoutReport.data" :key="member.counter">
										<td>{{ member.member_id }}</td>
										<td>{{ member.account_name }}</td>
										<td>{{ member.email }}</td>
										<td>{{ member.gross_amount }}</td>
										<td>{{ member.tax_withheld }}</td>
										<td>{{ member.processing_fee }}</td>
										<td>{{ member.net_amount }}</td>
									</tr>
									<tr v-if="payoutReport.data.length<=0">
										<td colspan="7">
											<p class="m-0 fw-bold h5 text-center text-danger">No Record Found</p>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<pagination :collections="payoutReport" />
					</div>
				</div>

			</div>
		</div>
	</div>
	<div id="printPage"></div>
</template>


<script>

import { useForm } from '@inertiajs/inertia-vue3';
import { onMounted, ref, watch } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import AuthLayout from '../../../Layouts/AuthLayout';

export default {
	props:{
		payoutReport 	: Object,
		api_response	: Object,
		filters			: Object
	},
	layout: AuthLayout,
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const SiteUrl 		= Ziggy.url;
		const search 		= ref(props.filters.search??'');
		const date_start 	= ref(props.filters.date_start??'');
		const date_end 		= ref(props.filters.date_end??'');

		const searchRecord = (_is_reset) => {

								if(_is_reset==1)
								{
									search.value 		= "";
									date_start.value 	= "";
									date_end.value 		= "";
								}

								Inertia.get(
									route('admin.affiliate-program.payout-report'),
									{
										search 		: search.value,
										date_start	: date_start.value,
										date_end 	: date_end.value
									},
									{
										preserveState: true,
										preserveScroll: true,
										only: ['payoutReport','api_response','filters']
									}
								)
							}

		const exportTo = (type)=>{

			axios.get('/api/admin/affiliate-program/payout-report/exportto/'+type,{
					search 		: search.value,
					date_start	: date_start.value,
					date_end 	: date_end.value
				})
			   .then((res) => {
			   	const d 		= new Date();
			   	var file_name 	= "payout_report_"+d.getFullYear()+d.getMonth()+d.getDate();
			   	var header 		= "";
			   	var data 		= res.data.data;

			   	switch (type) {
					case 'csv':
						header = "application/csv";
						file_name = file_name+".csv";
						break;
					case 'excel':
						header = "application/vnd.ms-excel";
						file_name = file_name+".xls";
						break;
					// case 'print':
					// 	$("#printPage").html(data);
					// 	PrintData("printPage");
					// 	break;
				}

				if(type!="print")
				{
					let blob = new Blob([data], {header});
					let url = window.URL.createObjectURL(blob);
					downloadURI(url, file_name);
					window.URL.revokeObjectURL(url);
				}

		   	})

		}

		const downloadURI = (uri, name)=>{
			let link = document.createElement("a");
		    link.download = name;
		    link.href = uri;
		    link.click();
		}



		return{
			SiteUrl,
			search,
			date_start,
			date_end,
			searchRecord,
			exportTo,
			downloadURI,
		}

	},
}
</script>
